<template>
	<div>
        <compWrapper title="批量管理仓库发运方式映射" theme="primary">
			<article class="search-main clearfix margin-20">
				<div class="text-left">
					<Form inline ref="form" :model="formData">
						<FormItem label='系统发运方式' :labelWidth="120" :rules="required" prop="systemCarrierCode">
							<vInput class="pull-left" readonly v-model="formData.systemCarrierCode">
								<vIcon
									type="search"
									center
									slot="suffix"
									style="padding:6px;pointer-events: initial;"
									size="18"
									@click.native="handleModalsystem"
								/>
							</vInput>
							<!-- <vButton theme="primary" @click="handleModalsystem">搜索</vButton> -->
							<span v-show="formData.systemCarrierCode" class="color-primary margin-left-10">({{carrierCode}} {{carrierServiceName}})</span>
						</FormItem>
					</Form>
				</div>
				<div>
					<div class="text-right">
						<Form inline>
							<FormItem label='仓库' :labelWidth="80">
								<vSelect v-model="formData.warehouseCode" filterable clearable search>
									<vOption v-for="item in syswarehouses" :value="item.code" :key="item.id">{{ item.title }}({{item.code}})</vOption>
								</vSelect>
							</FormItem>
							<FormItem label='国家' :labelWidth="80">
								<vSelect v-model="formData.country" filterable clearable search>
									<vOption v-for="item in countries" :value="item.code?item.code:item.nameEn" :key="item.id">{{ item.code}} ({{item.nameEn}})</vOption>
								</vSelect>
							</FormItem>
							<Button class="margin-right-10" type="primary" @click="update" icon="ios-search">搜索</Button>
							<Button @click="resetdata" icon='md-refresh'>重置</Button>
						</Form>
					</div>
				</div>
			</article>
			<vTable
				class="margin-left-20 margin-right-20"
				:loading="loading"
				:columns="columns"
				:data="formList"
				size="small"
				ref="table"
				border
				>
			</vTable>
			<compSpage
			class="text-right margin-top-10 margin-left-20 margin-right-20"
			v-bind="{total,pageSize:formData.rows,current:formData.page}"
			@on-update="update"></compSpage>
            <div class="text-right padding-right-20 margin-top-20">
                <vButton @click="submit" theme="primary">确定</vButton>
                <vButton class="margin-left-10" @click="cancel" >取消</vButton>
            </div>
		</compWrapper>
	</div>
</template>
<script>
import { HttpGetBatchlist, HttpBatchUpdate} from "@/service/managechannel/managechannel";
import { mapState, mapGetters } from "vuex";
import TableList from "@components/templates/tablelist"
import compSpage from '@/components/boss/spage';
export default {
    components: {
		TableList,
		compSpage,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		systemTablelist: () => import("../../publictable/systemTablelist.vue"),
	},
    data(){
        return {
			formData:{
				page: 1,
                rows: 10,
				systemCarrierCode:"",
				warehouseCode:"",
				country:""
			},
			carrierCode:'',
			carrierServiceName:'',
			total:0,
			loading:false,
			datalist:[],
			required: [{
                required: true,
                message: "该信息不能为空,请填写"
			}],
        }
    },
    computed:{
		...mapState('boss',['sysshippingcode','syscarrier','sysservice','countries','syswarehouses']),
		formList(){
            return this.datalist || []
        },
		columns() {
            const _this = this
            return [
            {
                title: "仓库",
				key: 'warehouseTitle',
                render(h, { row,index }) {
                    return <div>{row.warehouseTitle}</div>
                }
			},
			{
                title: "仓库Shipping Method Code",
				key: 'warehouseCarrierCode',
				// show:
                render(h, { row,index }) {
					return h('Input',{
						props: {
							size:'small',
							value:row.warehouseCarrierCode
						},
						on: {
							'input':(event) => {
								row.warehouseCarrierCode = event
								_this.datalist[index] = row
							}
						},
					})
                }
			},
			{
                title: "仓库类型",
				key: 'warehouseType',
				query:true
			},
			]
        },
    },
    methods:{
		update(){
			const data = this.$refs.form.validate()
			if(!data) return
			this.loading = true;
			HttpGetBatchlist({
				...this.formData
			}).then(res=>{
				this.datalist = res.data

			},err=>{

			}).finally(res=>{
				this.loading = false
			})
		},
		resetdata(){
			this.formData = {
                page: 1,
                rows: 10,
                systemCarrierCode:"",
				warehouseCode:"",
				country:""
			};
			this.datalist = []
		},
		submit(){
			// console.log(this.datalist.length)
			if(this.datalist.length<1){
				this.$Message.error('提交数据不能为空');
			}else{
				let arrayList = this.datalist.map(item=>{
					return {
						id:item.id,
						warehouseCode:item.warehouseCode,
						carrierServiceApiCode:item.warehouseCarrierCode
					}
				})
				this.loading = true
				HttpBatchUpdate({
					systemCarrierCode:this.formData.systemCarrierCode,
					warehouseCarrierServiceEntitys:arrayList
				}).then(res=>{
					this.$Message.success(res.message);
					this.$router.push({
						name: 'sysmanageware',
					});
				}).finally(res=>{
					this.loading = false
				})
			}
		},
		cancel(){
			this.$router.push({
				name: 'sysmanageware',
			});
		},
        handleModalsystem(){
			this.$VModal.info({
				title: "系统发运方式",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("systemTablelist",{
						props:{
							// 'sysshippingcode','syscarrier','sysservice'
							sysshippingcode:this.sysshippingcode,
							syscarrier:this.syscarrier,
							sysservice:this.sysservice
						},
                        on:{
                            rows:(rows)=>{
								// carrierServiceCode,carrierCode,carrierServiceName
								this.$set(this.formData,'systemCarrierCode',rows.carrierServiceCode)
								this.$set(this.$data,'carrierCode',rows.carrierCode)
								this.$set(this.$data,'carrierServiceName',rows.carrierServiceName)
								// 请求数据
								this.update();
                                this.$VModal.destroy();
							},
							cancel:()=>{
								this.$VModal.destroy();
							}
                        }
                    })
				}
			})
		}
    }
}
</script>
